import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import axios from "axios";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Review.css";

const API_URL = process.env.REACT_APP_API_URL;

const Review = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await axios.get(`${API_URL}/reviews`);
        const updatedReviews = response.data.map((review) => ({
          img: `${API_URL}${review.image.replace(/\\/g, "/")}`,
          msg: review.description,
          name: review.name,
        }));
        setReviews(updatedReviews);
      } catch (error) {
        console.error("Error fetching reviews:", error.message);
        alert("Failed to fetch reviews. Please try again.");
      }
    };

    fetchReviews();
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="outer-main-div">
      {/* ✅ Heading moved outside the review-slider */}
      <h2 className="review-title text-center">
        What Our <span className="review-title-highlight">Customers</span> Say?
      </h2>
      <p className="review-subtitle text-center">
        Genuine voices from those who have experienced our service firsthand.
      </p>

      <div className="review-slider">
        <Slider {...settings}>
          {reviews.map((review, index) => (
            <div key={index} className="review-card-wrapper">
              <div className="review-card">
                <img
                  src={review.img}
                  alt={review.name}
                  className="review-img"
                />
                <div className="flex-grow-1">
                  <p className="review-msg">"{review.msg}"</p>
                  <p className="review-name">{review.name}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Review;
